import { Api } from "./generated";

const api = Api.enhanceEndpoints({
	addTagTypes: ["device", "user", "location", "alert", "alert_rule"],
	endpoints: {
		getDevices: {
			providesTags: ["device"],
		},
		patchDevicesById: {
			invalidatesTags: ["device"],
		},
		// alternatively, define a function which is called with the endpoint definition as an argument
		getLocations(endpoint) {
			endpoint.providesTags = ["location"];
			endpoint.keepUnusedDataFor = 120;
		},
		postDevices: {
			invalidatesTags: ["device"],
		},
		deleteDevicesById: {
			invalidatesTags: ["device"],
		},
		postLocations: {
			invalidatesTags: ["location"],
		},
		patchLocationsById: {
			invalidatesTags: ["location"],
		},
		deleteLocationsById: {
			invalidatesTags: ["location"],
		},
		// Alerts
		getAlertRules: {
			providesTags: ["alert_rule"],
		},
		postAlertRules: {
			invalidatesTags: ["alert_rule"],
		},
		putAlertRulesByRuleId: {
			// invalidatesTags: ['alert_rule'],
			async onQueryStarted({ ruleId, body }, { dispatch, queryFulfilled }) {
				/**
				 * Optimistically update the cache
				 */
				const patchResult = dispatch(
					Api.util.updateQueryData(
						"getAlertRules",
						{ deviceId: body.device_id },
						(draftRules) => {
							const ruleIndex = draftRules.data.items.findIndex(
								(rule) => rule.id === ruleId,
							);
							if (ruleIndex !== -1) {
								draftRules.data.items[ruleIndex] = {
									...draftRules.data.items[ruleIndex],
									...body,
								};
							}
						},
					),
				);
				try {
					await queryFulfilled;
				} catch {
					patchResult.undo();

					/**
					 * Alternatively, on failure you can invalidate the corresponding cache tags
					 * to trigger a re-fetch:
					 * dispatch(api.util.invalidateTags(['Post']))
					 */
					dispatch(Api.util.invalidateTags(["alert_rule"]));
				}

				/**
				 * Pessimistically update the cache
				 */
				// try {
				//   const { data: updatedRule } = await queryFulfilled
				//   const patchResult = dispatch(
				//     Api.util.updateQueryData('getAlertRules', {deviceId: body.device_id}, (draftRules) => {
				//       const ruleIndex = draftRules.data.items.findIndex((rule) => rule.id === updatedRule.data.id);
				//       if (ruleIndex !== -1) {
				//         draftRules.data.items[ruleIndex] = {
				//           ...draftRules.data.items[ruleIndex],
				//           ...updatedRule.data,
				//         };
				//       }
				//     }),
				//   )
				// } catch {}
			},
		},
		deleteAlertRulesByRuleId: {
			invalidatesTags: ["alert_rule"],
		},
		getAlerts: {
			providesTags: ["alert"],
		},
		getAlertsHistory: {
			providesTags: ["alert"],
		},
		postAlertsByAlertIdAcknowledge: {
			invalidatesTags: ["alert"],
		},
		postAlertsByAlertIdResolve: {
			invalidatesTags: ["alert"],
		},
		getTenants: {
			providesTags: ["tenants"],
		},
		patchTenantsById: {
			invalidatesTags: ["tenants"],
		},
		deleteTenantsById: {
			invalidatesTags: ["tenants"],
		},
		// Export endpoints - configure to return blob for binary file downloads
		getExportSensorData(endpoint) {
			endpoint.query = (queryArg) => ({
				url: `/export/sensor-data`,
				headers: {
					"x-tenant-id": queryArg["x-tenant-id"],
				},
				params: {
					device_ids: queryArg.deviceIds,
					sensor_types: queryArg.sensorTypes,
					location_id: queryArg.locationId,
					location_ids: queryArg.locationIds,
					start_date: queryArg.startDate,
					end_date: queryArg.endDate,
					format: queryArg.format,
				},
				responseHandler: "blob",
			});
		},
		getExportSensorAggregates(endpoint) {
			endpoint.query = (queryArg) => ({
				url: `/export/sensor-aggregates`,
				headers: {
					"x-tenant-id": queryArg["x-tenant-id"],
				},
				params: {
					location_id: queryArg.locationId,
					location_ids: queryArg.locationIds,
					device_id: queryArg.deviceId,
					device_ids: queryArg.deviceIds,
					start_date: queryArg.startDate,
					end_date: queryArg.endDate,
					sensor_types: queryArg.sensorTypes,
					interval: queryArg.interval,
					format: queryArg.format,
					chart_type: queryArg.chartType,
					limit: queryArg.limit,
					offset: queryArg.offset,
				},
				responseHandler: "blob",
			});
		},
		getExportSensorTimeSeries(endpoint) {
			endpoint.query = (queryArg) => ({
				url: `/export/sensor-time-series`,
				headers: {
					"x-tenant-id": queryArg["x-tenant-id"],
				},
				params: {
					device_ids: queryArg.deviceIds,
					sensor_types: queryArg.sensorTypes,
					location_id: queryArg.locationId,
					start_date: queryArg.startDate,
					end_date: queryArg.endDate,
					interval: queryArg.interval,
					aggregation: queryArg.aggregation,
					format: queryArg.format,
					chart_type: queryArg.chartType,
					limit: queryArg.limit,
					tenant_id: queryArg.tenantId,
				},
				responseHandler: "blob",
			});
		},
	},
});

export { api };
